import { Link, useNavigate } from "react-router-dom";
import { Grid2x2, LogOut, Trophy, ShieldCheck, Play } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const WIDTH = { narrow: "max-w-md", wide: "max-w-md md:max-w-4xl lg:max-w-5xl" };

export function Shell({ children, hideNav = false, width = "narrow" }) {
  const { user, signOut } = useAuth();
  const nav = useNavigate();
  const link = "flex items-center gap-1.5 rounded-lg p-2 text-sm font-medium text-slate-400 transition-colors hover:bg-slate-800 hover:text-white md:px-3";
  return (
    <div className="min-h-screen bg-[#0B0F17] text-slate-100">
      <div className={`mx-auto flex min-h-screen w-full flex-col px-5 pb-10 pt-5 md:px-8 md:pt-7 ${WIDTH[width]}`}>
        <header className="mb-6 flex items-center justify-between md:mb-10" data-testid="app-header">
          <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
            <span className="grid h-8 w-8 place-items-center rounded-lg bg-white text-slate-900"><Grid2x2 size={18} strokeWidth={2.5} /></span>
            <span className="font-display text-base font-bold tracking-tight md:text-lg">Quizmoney</span>
            <span className="eyebrow ml-1 rounded-full border border-red-500/40 px-1.5 py-0.5 text-[9px] text-red-400">SG</span>
          </Link>
          {!hideNav && (
            <nav className="flex items-center gap-1">
              {user && <Link to="/play" className={link} data-testid="nav-play-link" aria-label="Play"><Play size={18} /><span className="hidden md:inline">Play</span></Link>}
              <Link to="/leaderboard" className={link} data-testid="nav-leaderboard-link" aria-label="Leaderboard"><Trophy size={18} /><span className="hidden md:inline">Leaderboard</span></Link>
              {user?.role === "admin" && <Link to="/admin" className={link} data-testid="nav-admin-link" aria-label="Admin"><ShieldCheck size={18} /><span className="hidden md:inline">Admin</span></Link>}
              {user ? (
                <button onClick={() => { signOut(); nav("/"); }} className={link} data-testid="nav-logout-button" aria-label="Log out"><LogOut size={18} /><span className="hidden md:inline">Log out</span></button>
              ) : (
                <Link to="/login" className={`${link} hidden md:flex`} data-testid="nav-login-link">Log in</Link>
              )}
            </nav>
          )}
        </header>
        <main className="flex flex-1 flex-col">{children}</main>
      </div>
    </div>
  );
}
